import _ from 'lodash';
import { storeGetters, NotFound, Loading, permissions } from '~';
import { mapActions, mapState } from 'vuex';
import { STEP_STATUS, CREATIVE_STATUSES } from '@/util/constants';
import CreativeStep from '@/components/rabbit/creative-step/CreativeStep.vue';
import WorkflowProgress from '@/components/rabbit/workflow-progress/WorkflowProgress.vue';

export default {
  components: {
    Loading,
    NotFound,
    'creative-step': CreativeStep,
    'workflow-progress': WorkflowProgress,
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('creative', {
      creative: 'current',
      loadingCreative: 'loading',
      error: 'error',
    }),
    ...mapState('genericConfig', {
      loadingConfig: 'loading',
    }),
    permissions() {
      return permissions.getPermissions(this.creative);
    },
    loading() {
      return this.loadingCreative || this.loadingConfig;
    },
    statuses() {
      return _.get(this.creative, 'statuses', {});
    },
    steps() {
      const steps = [];
      let waiting = false;
      _.forOwn(this.statuses, (value, slug) => {
        let status = value.current  // eslint-disable-line
          ? STEP_STATUS.in_progress
          : (waiting
              ? STEP_STATUS.waiting
              : STEP_STATUS.completed);
        if (slug === CREATIVE_STATUSES.APPROVED && status === STEP_STATUS.in_progress) {
          status = STEP_STATUS.completed;
        }

        steps.push({
          name: this.$t('fn.complex.creative-flow-statuses-title', { slug }),
          slug,
          status,
          startedAt: value.started_at,
          finishedAt: value.finished_at,
        });
        if (value.current) waiting = true;
      });
      return steps;
    },
    currentStatus() {
      return _.get(this.statuses, _.get(this.creative, 'status', null), null);
    },
    canViewProgress() {
      return permissions.canGlobal(this.user, 'Creative', ['viewProgress']);
    },
  },
  methods: {
    ...mapActions('creative', ['getCreative']),
  },
  mounted() {
    this.getCreative(storeGetters.getRouterParams().id)
      .then(() => {
        if (this.error && ![404, 403].includes(this.error.code)) {
          this.$toast.error({ message: this.error });
        }
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/rabbit/creative/Creative.js